// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zOoqQqpnu3Wyt4B3TtGK{position:relative;display:flex;flex-grow:1;flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/tags/ui/TaggedContactsTable/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,YAAA,CACA,WAAA,CACA,qBAAA","sourcesContent":[".table {\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `zOoqQqpnu3Wyt4B3TtGK`
};
export default ___CSS_LOADER_EXPORT___;
